export const startServiceReport = async (id, payload = {}) => {
  const BASE_URL = "https://p00rho0596.execute-api.ap-southeast-1.amazonaws.com/prod";
  const response = await fetch(`${BASE_URL}/start-service-report/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.error || "Failed to start service report");
  }

  return data;
};